var STARRED_PROJECTS = 'STARRED_PROJECTS';
export { STARRED_PROJECTS };